import React, {useEffect, useState} from "react"
import styles from "./Navigation.module.css"
import newsSvg from '../../assets/img/nav/news2.svg'
import calendarSvg from '../../assets/img/nav/calendar2.svg'
import docSvg from '../../assets/img/nav/doc2.svg'
import proposalSvg from '../../assets/img/nav/proposal.svg'
import PaymentSvg from '../../assets/img/nav/payments.svg'
import ExchangeRateSvg from '../../assets/img/nav/exchange-rate.svg'
import ContactsSvg from '../../assets/img/nav/contactsSvg.svg'
import DeclarationSvg from '../../assets/img/nav/declaration.svg'
import ApparatPpo from '../../assets/img/nav/ppo.svg'
import WorkCalendarSvg from '../../assets/img/nav/work-calendar.svg'
import PauseSvg from '../../assets/img/nav/pause.svg'
import {NavLink} from "react-router-dom"
import {ContestBanner} from "../Event/Contest/ContestBanner/ContestBanner";
import NewYearEvent from "../Event/NewYearEvent/NewYearEvent";
import Story from "../Stories/Story";
import {useDispatch, useSelector} from "react-redux";
import {fetchStories} from "../Stories/storiesSlice";

const Navigation = () => {
    const dispatch = useDispatch()
    const allStories = useSelector(state => state?.storiesSlice?.stories)
    const [storiesWithImages, setStoriesWithImages] = useState([]);
    useEffect(() => {
        dispatch(fetchStories())
    }, []);
    useEffect(() => {
        if (allStories) {
            const storiesWithImages = allStories.map((story) => {
                const info = story.name
                const text = story.text
                const url = story.url
                const active = story.active
                const images = story.media.map((image) => image.image);
                return {story, images, info, text, url, active};
            });
            setStoriesWithImages(storiesWithImages);
        }
    }, [allStories]);
    return (
        <>
            <div className="content-wrapper">
                <div style={{display: "flex"}}>
                {storiesWithImages.map(({images, text, description, url, active}, index) => (
                    <Story
                        key={index}
                        text={text}
                        description={description}
                        url={url}
                        active={active}
                        stories={images.map(url => ({ url }))}
                    />

                ))}
            </div>

                <div className="page-title-container">
                    <span className={styles.title}>«ЛУКОЙЛ – Многофункциональный Центр Поддержки Бизнеса» Нефтегазстройпрофсоюза России</span>
                </div>
                {}
                <ContestBanner/>
                <NewYearEvent/>

                <div className={styles.navigation}>
                    <NavLink to='/news' className={styles.navigationItem}>
                        <img src={newsSvg} alt={'Новости'}/>
                        <div>Новости</div>
                    </NavLink>
                    <NavLink to='/calendar' className={styles.navigationItem}>
                        <img src={calendarSvg}/>
                        <div>Календарь</div>
                    </NavLink>
                    <NavLink to={'/payments'} className={styles.navigationItem}>
                        <img src={PaymentSvg}/>
                        <div>Выплаты</div>
                    </NavLink>
                    <NavLink to='/documents' className={styles.navigationItem}>
                        <img src={docSvg}/>
                        <div>Документы</div>
                    </NavLink>
                    <NavLink to='/proposal' className={styles.navigationItem}>
                        <img src={proposalSvg}/>
                        <div>Акции</div>
                    </NavLink>
                    <NavLink to={'/tickets'} className={styles.navigationItem}>
                        <img src={ContactsSvg}/>
                        <div>Вопрос ОППО</div>
                    </NavLink>
                    <NavLink to={'/ticketsAbout'} className={styles.navigationItem}>
                        <img src={ApparatPpo}/>
                        <div>Аппарат ОППО</div>
                    </NavLink>
                    <NavLink to={'/declaration'} className={styles.navigationItem}>
                        <img src={DeclarationSvg}/>
                        <div>Заявления</div>
                    </NavLink>
                    <NavLink to={'/exchange-rates'} className={styles.navigationItem}>
                        <img src={ExchangeRateSvg} alt={'Курс валют'}/>
                        <div>Курс валют</div>
                    </NavLink>
                    <NavLink to={'/work-calendar'} className={styles.navigationItem}>
                        <img src={WorkCalendarSvg} alt={'Производственный календарь'}/>
                        <div>Произв. календарь</div>
                    </NavLink>
                    <NavLink to={'/pause'} className={styles.navigationItem}>
                        <img src={PauseSvg} alt={'Пауза'}/>
                        <div>Пауза</div>
                    </NavLink>
                </div>
            </div>
        </>
    )
}
export default Navigation
